import React from 'react';

import styles from './userBadgesPageStyles';

import BadgeDisplayOnProfileCheckboxContainer from 'buyside/components/container/UserAccount/BadgeDisplayOnProfileCheckboxContainer';
import Icon from 'buyside/components/presentation/Icon/icon';

import AceAnalystIcon from 'SVGs/badges/ace_analyst';
import CriticIcon from 'SVGs/badges/critic';
import FlavorOfWeekIcon from 'SVGs/badges/flavor_of_week';
import FundIcon from 'SVGs/badges/fund';
import GrandChampionIcon from 'SVGs/badges/grand_champion';
import InfluencerIcon from 'SVGs/badges/influencer';
import MasterAnalystIcon from 'SVGs/badges/master_analyst';
import PaladinIcon from 'SVGs/badges/paladin';
import RankedIcon from 'SVGs/badges/ranked';
import TopRankedIcon from 'SVGs/badges/top_ranked';

import { formatDate } from 'buyside/util/dateHelper';

const badgeIconMapping = {
  1: RankedIcon,
  2: TopRankedIcon,
  3: CriticIcon,
  4: InfluencerIcon,
  5: PaladinIcon,
  6: FundIcon,
  7: FlavorOfWeekIcon,
  8: GrandChampionIcon,
  9: MasterAnalystIcon,
  10: AceAnalystIcon
};

const BadgeCard = ({ badgeInfo, earned }) => {
  const { id: badgeInfoId, badgeNumber, earnedAt, visible, badge } = badgeInfo;
  const { id, name, description } = badge || badgeInfo;
  // === Unearned Badges ===
  // A Badge object is passed down as the badgeInfo prop.
  // The name and description fields are on Badge, which is the badgeInfo prop itself.
  // Hence, those fields are destructured directly from badgeInfo
  // === Earned Badges ===
  // A BadgeCollectionRelationship object, in which the corresponding Badge object is nested,
  // is passed down as the badgeInfo prop (refer to: badge_collection_relationship_type.rb).
  // The Badge object **inside the badgeInfo prop object** has the name and description fields.
  // Hence, those fields are destructured from badgeInfo.badge
  // - 22 Apr 2019 (TMA)

  return (
    <div>
      <div className={styles.cardContainer}>
        <div>
          <Icon
            type={badgeIconMapping[id]}
            style={earned ? styles.regularBadgeIcon : styles.fadedBadgeIcon}
          />
        </div>
        <div>
          <strong>{name}</strong>
          <div className={styles.badgeDescription}>{description}</div>
          {earned ? (
            <div>
              <div className={styles.earningDetailSection}>
                {badgeNumber > 1 ? (
                  <div>
                    <strong>Earned: </strong>
                    <span>{badgeNumber}X</span>
                  </div>
                ) : null}
                <div>
                  <span className={styles.date}>Last Earned: </span>
                  {formatDate(earnedAt)}
                </div>
              </div>
              <BadgeDisplayOnProfileCheckboxContainer
                initialValues={{ badgeCollectionRelationshipId: badgeInfoId, visible: visible }}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BadgeCard;
